import { useMemo, useRef } from "react";

export const useStableCallbacks = (values) => {
  const latest = useRef(values);
  latest.current = values;
  const wrappers = useRef({});
  const keys = Object.keys(values);
  const data = keys.map((key) => (typeof values[key] === "function" ? null : values[key]));

  return useMemo(() => {
    const stable = {};
    keys.forEach((key) => {
      const value = latest.current[key];
      if (typeof value !== "function") {
        stable[key] = value;
        return;
      }
      if (!wrappers.current[key]) wrappers.current[key] = (...args) => latest.current[key](...args);
      stable[key] = wrappers.current[key];
    });
    return stable;
  }, [keys.join("|"), ...data]);
};
